import React from 'react';
import { useSelector } from 'react-redux';
import { openInNewTab } from '../../../../utils/utils';
import { ButtonType } from '../../../../ui/buttonTypes';
import iconsList from '../../../ui/icons/iconsList';
import FinalWhatToExpectItem from './FinalWhatToExpectItem/FinalWhatToExpectItem';
import BtnComponent from '../../../ui/buttons/BtnComponent';
import classes from './FinalWhatToExpect.module.css';

const FinalWhatToExpect = () => {

  const { finalData, contentInfoJson } = useSelector((state) => state.contest);
  const { texts } = useSelector((state) => state.translate);

  return (
    <div className={classes.card}>
      <p className={classes.title}>{texts?.finalSection_whatInFinal}</p>
      <div className={classes.itemsRow}>
        {
          contentInfoJson?.final?.finalInfo?.isLive &&
          <>
            <FinalWhatToExpectItem icon={iconsList.camera} value={contentInfoJson?.final?.finalInfo?.isLive ? 'Live' : '—'} label={texts?.finalSection_liveLabel} />
            <span className={classes.iconDivider} />
          </>
        }
        <FinalWhatToExpectItem icon={iconsList.finalStages} value={contentInfoJson?.final?.finalInfo?.stages ?? '—'} label={texts?.finalSection_stagesLabel} />
        <span className={classes.iconDivider} />
        <FinalWhatToExpectItem icon={iconsList.finalParticipants} value={contentInfoJson?.final?.finalInfo?.participants ?? '—'} label={texts?.finalSection_participantsLabel} />
        <span className={classes.iconDivider} />
        <FinalWhatToExpectItem icon={iconsList.finalMinutes} value={contentInfoJson?.final?.finalInfo?.minutes ?? '—'} label={texts?.finalSection_minutesLabel} />
      </div>
      <div className={classes.footer}>
        <BtnComponent type={ButtonType.FINALISTS_LIST} showFinalistsListPopup={true} />
        <p onClick={() => openInNewTab(finalData?.regulationUrl)} className={classes.regulationsLink}>
          {texts?.finalSection_toRegulations}
        </p>
      </div>
    </div>
  );
};

export default FinalWhatToExpect;
